import React, { useRef } from 'react';
import { IconButton, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import classes from './cardUpload.module.css';

const SLOTS = ['Front of card', 'Back of card'];

const CardUploadSlots = ({
    filePreviews = [],
    placeholderSrc,
    placeholderAlt = 'Card sample',
    onSelect,
    onRemove,
    error = false,
}) => {
    const frontInputRef = useRef(null);
    const backInputRef = useRef(null);
    const inputRefs = [frontInputRef, backInputRef];

    const handleChange = (index) => (event) => {
        const file = event.target.files?.[0];
        if (inputRefs[index].current) inputRefs[index].current.value = '';
        if (file) onSelect?.(index, file);
    };

    return (
        <div className={classes.UploadBlock}>
            <div className={classes.Reference}>
                <div className={classes.ReferenceFrame}>
                    <img
                        src={placeholderSrc}
                        alt={placeholderAlt}
                        className={classes.ReferenceImage}
                    />
                </div>
                <Typography className={classes.ReferenceCaption} component="p">
                    Sample
                </Typography>
            </div>

            <div className={classes.PreviewRow}>
                {SLOTS.map((label, index) => {
                    const previewURL = filePreviews[index];
                    return (
                        <div key={label} className={classes.ImageSlot}>
                            <Typography
                                component="p"
                                sx={{ mb: 0.75, fontWeight: 700, color: '#334155', fontSize: '13px' }}
                            >
                                {label}
                            </Typography>
                            <div className={`${classes.ImageFrame} ${previewURL ? classes.ImageFrameFilled : ''} ${error && !previewURL ? classes.ImageFrameError : ''}`}>
                                {previewURL ? (
                                    <>
                                        <img
                                            src={previewURL}
                                            alt={label}
                                            className={classes.PreviewImage}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={() => onRemove(index)}
                                            className={classes.CancelIconButton}
                                            aria-label={`Remove ${label.toLowerCase()}`}
                                        >
                                            <CancelIcon />
                                        </IconButton>
                                    </>
                                ) : (
                                    <label className={classes.UploadTrigger}>
                                        <CloudUploadOutlinedIcon className={classes.UploadIcon} />
                                        <input
                                            hidden
                                            type="file"
                                            accept=".jpg, .jpeg, .png"
                                            onChange={handleChange(index)}
                                            ref={inputRefs[index]}
                                        />
                                    </label>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CardUploadSlots;
